import { type PriceListRatioCoefficientRowData, RatioRecordStatusEnum } from 'gql/graphql';
import { Button, ContextMenu, IconKebab, IconExpand } from 'uikit';

import type React from 'react';
import { useCallback, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { RatioUers } from '../RatioUers/RatioUers';

interface IPriceListFactorsRowMenu {
    row: PriceListRatioCoefficientRowData;
}

const style = { width: 16, height: 16, marginRight: 6 };

export const PriceListFactorsRowMenu: React.FC<IPriceListFactorsRowMenu> = (props) => {
    const { row } = props;
    const [isOpen, setIsOpen] = useState(false);
    const [isRatioUersOpen, setIsRatioUersOpen] = useState(false);
    const ref = useRef(null);
    const navigate = useNavigate();

    const handleOnClick = useCallback(() => {
        setIsOpen((prevState) => !prevState);
    }, []);

    const handleItemClick = useCallback((): any => {
        navigate(`editCoeff/${row.id}`);

        handleOnClick();
    }, [handleOnClick, navigate, row]);

    const isDisabled = ![RatioRecordStatusEnum.Draft, RatioRecordStatusEnum.NewRecord].includes(row.status);

    const switchRatioUerModalOpen = useCallback(() => {
        setIsRatioUersOpen(!isRatioUersOpen);
    }, [isRatioUersOpen]);

    return (
        <>
            <Button
                style={style}
                iconLeft={IconKebab}
                onlyIcon
                view={isDisabled ? 'primary' : 'clear'}
                size="xs"
                ref={ref}
                onClick={handleOnClick}
                disabled={isDisabled}
            />
            <Button onClick={switchRatioUerModalOpen} iconLeft={IconExpand} onlyIcon view="clear" size="xs" />
            <ContextMenu
                isOpen={isOpen}
                items={['Редактировать']}
                getItemLabel={(item) => item}
                anchorRef={ref}
                direction="downStartLeft"
                getItemOnClick={handleItemClick}
                onClickOutside={handleOnClick}
            />
            {isRatioUersOpen && <RatioUers onClose={switchRatioUerModalOpen} ratio={row} />}
        </>
    );
};

PriceListFactorsRowMenu.displayName = 'PriceListFactorsRowMenu';
